import { render, staticRenderFns } from "./InvoicesTotals.vue?vue&type=template&id=79d85f12"
import script from "./InvoicesTotals.vue?vue&type=script&lang=js"
export * from "./InvoicesTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports